export const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

export const isPasswordStrong = (pwd: string): boolean => {
  const minLength = /.{8,}/;
  const uppercase = /[A-Z]/;
  const lowercase = /[a-z]/;
  const number = /[0-9]/;
  const special = /[^A-Za-z0-9]/;

  return (
    minLength.test(pwd) &&
    uppercase.test(pwd) &&
    lowercase.test(pwd) &&
    number.test(pwd) &&
    special.test(pwd)
  );
};
